
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppCommonUser} from "@/models/app/common/User";

// Components
import {
  ElRow,
  ElCol,
  ElForm,
  ElFormItem,
  ElSelect,
  ElOption,
} from "element-plus";

@Options({
  props: [
    "players",
  ],
  components: {
    ElRow,
    ElCol,
    ElForm,
    ElFormItem,
    ElSelect,
    ElOption,
  },
})
export default class AppAdministratorHealthRecordsRootFilterIndexVue extends Vue {
  players: Array<AppCommonUser> = [];

  formData: any = {
    filter: {
      user_id: "*",
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  getHealthRecordsByFilter(): void {
    this.$emit("getHealthRecordsByFilter", this.formData);
  }
}
